import React from 'react'

const Error = () => {
  return (
    <div className='font-bold text-xl'>404</div>
  )
}

export default Error